import { render, staticRenderFns } from "./radishDrawerFunction.vue?vue&type=template&id=5f647429&scoped=true"
import script from "./radishDrawerFunction.vue?vue&type=script&lang=js"
export * from "./radishDrawerFunction.vue?vue&type=script&lang=js"
import style0 from "./radishDrawerFunction.vue?vue&type=style&index=0&id=5f647429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f647429",
  null
  
)

export default component.exports